import { render, staticRenderFns } from "./PaymentMethodsForm.vue?vue&type=template&id=2ddee10c&scoped=true"
import script from "./PaymentMethodsForm.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddee10c",
  null
  
)

export default component.exports